import { Deserializable } from './deserializable.model';

export class RemoteFirstVisit implements Deserializable<any, RemoteFirstVisit> {
  constructor(
    public checkInCount = 0,
    public completedReflection = false,
    public dismissedAccountCreationModal = false,
    public discover = false,
    public firstActionAdded = false,
    public firstQuestAdded = false,
    public firstTimeAppVisit = false,
    public initialDailyChallenge = false,
    public lastModalLaunch: string = new Date(0).toISOString(),
    public progress = false,
    public purposefulVisits = 0, // Starts counting after acknowledging Today first visit messages
    public resourcefulVisits = 0,
    public shownCrossPromotionModal = false,
    public shownExpandedLiveSupport = false,
    public shownNotificationsModal = false,
    public shownPurposefulFeedbackModal = false,
    public shownResourcefulFeedbackModal = false,
    public today = false,
    public webMigrated = false
  ) {}

  deserialize(json?: any, previousValue?: RemoteFirstVisit): RemoteFirstVisit {
    if (json != null || previousValue != null) {
      Object.assign(this, previousValue || {}, json);
    }
    return this;
  }
}
